// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ActivityGoalChartController from "./activity_goal_chart_controller"
application.register("activity-goal-chart", ActivityGoalChartController)

import PostureBarChartController from "./posture_bar_chart_controller"
application.register("posture-bar-chart", PostureBarChartController)

import DailyActivityGoalsModalController from "./daily_activity_goals_modal_controller"
application.register("daily-activity-goals-modal", DailyActivityGoalsModalController)

import NicknameModalController from "./nickname_modal_controller"
application.register("nickname-modal", NicknameModalController)

import CommentModalController from "./comment_modal_controller"
application.register("comment-modal", CommentModalController)

import MonthlyBarChartController from "./monthly_bar_chart_controller"
application.register("monthly-bar-chart", MonthlyBarChartController)

import MonthlyLineChartController from "./monthly_line_chart_controller"
application.register("monthly-line-chart", MonthlyLineChartController)

import MonthlyStackedBarChartController from "./monthly_stacked_bar_chart_controller"
application.register("monthly-stacked-bar-chart", MonthlyStackedBarChartController)

import AdviceModalController from "./advice_modal_controller"
application.register("advice-modal", AdviceModalController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import CsvDownloadModalController from "./csv_download_modal_controller"
application.register("csv-download-modal", CsvDownloadModalController)

import AccessLogCsvModalController from "./access_log_csv_modal_controller"
application.register("access-log-csv-modal", AccessLogCsvModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ApiPlaygroundController from "./api_playground_controller"
application.register("api-playground", ApiPlaygroundController)
